import React, { forwardRef } from 'react';
import styled from '@emotion/styled';

import { Modal } from '../../../../components/Modals/Modal';
import ModalTriggerContainer from '../../../../components/Modals/ModalTriggerContainer';
import { ModalProvider } from '../../../../context/ModalContext';
import JobFilterModal from '../../../../components/Modals/ModalsActions/JobFilterModal';

interface JobFilterButtonProps {
  onFilterSubmit?: (values: any) => void;
}

const JobFilterButton = forwardRef<HTMLDivElement, JobFilterButtonProps>(
  ({ onFilterSubmit }, ref) => {
    return (
      <ModalProvider>
        <ModalTriggerContainer ref={ref}>
          <None />
        </ModalTriggerContainer>
        <Modal>
          <JobFilterModal onFilterSubmit={onFilterSubmit} />
        </Modal>
      </ModalProvider>
    );
  }
);

export default JobFilterButton;

const None = styled.div`
  display: none;
`;
